import {
    GET_BOOKING_INFO_LOADING, GET_MULTIPLE_BOOKINGS_INFO_LOADING, BOOKING_DATA_SUCCESS,
    BOOKING_DATA_ERROR, BOOKING_DATA_RESET, BOOKING_DATA_UPDATE_QUANTITY
} from "../actions/actionBooking";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey1 = "bookingrecord";

const initialState = {
    booking: loadState(sessionKey1, []),
    loading: false,
    bookingError: ''
};

function reducerBooking(state = initialState, action) {

    switch (action.type) {
        case GET_BOOKING_INFO_LOADING: {
            return {
                ...state,
                loading: true
            };
        }

        case GET_MULTIPLE_BOOKINGS_INFO_LOADING: {
            return {
                ...state,
                loading: true
            };
        }

        case BOOKING_DATA_SUCCESS: {

            saveState(sessionKey1, action.payload)

            return {
                ...state,
                loading: false,
                booking: action.payload,
                bookingError: ''
            };
        }

        case BOOKING_DATA_RESET: {

            saveState(sessionKey1, [])

            return {
                ...state,
                booking: [],
                loading: false,
                bookingError: ''
            };
        }

        case BOOKING_DATA_ERROR: {

            saveState(sessionKey1, [])

            let error = "";
            if (action.error.Errors) {
                error = action.error.Errors;
            }
            else
                error = action.error;

            return {
                ...state,
                loading: false,
                bookingError: error
            }
        }

        case BOOKING_DATA_UPDATE_QUANTITY: {

            let booking = [...state.booking]

            booking[0].BookingProducts = booking[0].BookingProducts.map(prod => {

                if (prod.TourProductID == action.payload.prodID) {
                    prod.newQuantity = action.payload.quantity;
                    prod.isModify = true;
                }

                return prod;
            });

            saveState(sessionKey1, booking);

            return {
                ...state,
                loading: false,
                booking: booking
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerBooking;